<template>
  <div class="app-container">
    <!--主页面表单-->
    <div class="filter-container">
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">刷新</el-button>
      <el-button class="filter-item pdf" @click="showManual">运营后台导出操作手册</el-button>
    </div>

    <el-table
      :data="list"
      v-loading="listLoading"
      fit
      border
      highlight-current-row
      style="width: 100%"
      max-height="550"
    >
      <el-table-column align="left" label="操作时间" width="150px">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}')}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="任务">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作人员" width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.operator}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="文件" width="120px">
        <template slot-scope="scope">
          <span>
            <!-- canDownload，1:可下载，2:不可下载 -->
            <el-button
              v-if="scope.row.file != ''"
              type="text"
              :disabled="scope.row.canDownload==2"
              @click="downloadFile(scope.row.email, scope.row.file)"
            >下载</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="记录数量" width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.file != ''? scope.row.count + '条': ''}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="状态" width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.status | statusDisplay}}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="导出验证" :visible.sync="verifyDialogVisible" width="400px">
      <p>为保证数据安全，已向您的邮箱{{email}}发送验证码，验证码有效时长5分钟。</p>
      <p>
        <el-input style="width: 200px" v-model="verifyCode" placeholder="验证码"></el-input>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doVerifyExport">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="pdf" :visible.sync="pdfVisible" width="80%" class="pdf-dialog">
      <iframe src="/11.pdf#toolbar=0" frameborder="0" style="width: 100%; height: 80vh"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "SystemExportJobList",
  data() {
    return {
      isSuper: store.getters.user.isSuper,
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      roles: [],
      file: "",
      email: "",
      verifyCode: "",
      code: "",
      verifyDialogVisible: false,
      src: "",
      pdfVisible: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  filters: {
    statusDisplay(status) {
      const statusMap = {
        "0": "等待中",
        "1": "完成",
        "2": "处理中",
        "3": "失败"
      };
      return statusMap[status];
    }
  },

  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
  },
  methods: {
    doReset() {
      this.list = null;
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10
      };
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/exportJobList", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit
        })
        .then(function(response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    showManual() {
      this.pdfVisible = true;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    downloadFile(email, file) {
      var a = document.createElement("a");
      a.href = file;
      a.click();
      return;
    },
    doVerifyExport() {
      if (this.verifyCode === "") {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
        return;
      }
      if (this.verifyCode === this.code) {
        var a = document.createElement("a");
        a.href = this.file;
        a.click();
        this.verifyDialogVisible = false;
      } else {
        this.$message({
          message: "验证码不正确",
          type: "warning"
        });
        return;
      }
    }
  }
};
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.filter-container {
  display: flex;
  justify-content: space-between;
}
.pdf-dialog {
  margin-top: -10vh !important;
}
.filter-item.pdf {
  background-color: #409eff;
  color: #fff;
}
.filter-item.pdf:hover {
  background-color: #409eff;
  color: #fff;
}
</style>
